<template>
  <footer>
    <div class="container">
      <div>
        <router-link to="/" tag="div" class="logo">
          <img src="@/assets/img/logo.svg" alt="logo_image" />
        </router-link>
        <h6 class="copyright">
          Copyright © Bridgeport United FC 2020.
          <br />All rights reserved.
        </h6>
        <ul class="privacy-list">
          <router-link tag="li" v-for="link in privacy" :key="link.id" :to="link.url">{{link.title}}</router-link>
        </ul>
      </div>
      <div v-for="item in menu" :key="item.menuTitle">
        <h5 class="title">{{item.menuTitle}}</h5>
        <ul class="menu">
          <li v-if="item.shop == true">
            <a
              target="_blank"
              href="https://macronstorect.tuosystems.com/stores/bptunited"
            >BUFC gear</a>
          </li>
          <router-link
            v-else
            tag="li"
            v-for="link in item.list"
            :key="link.id"
            :to="link.url"
          >{{link.title}}</router-link>
        </ul>
      </div>

      <div>
        <h5 class="title">{{other.menuTitle}}</h5>
        <ul class="menu">
          <li class="not-router">
            <a
              target="_blank"
              href="https://macronstorect.tuosystems.com/stores/bptunited"
            >BUFC gear</a>
          </li>
          <router-link tag="li" :to="other.list.url">{{other.list.title}}</router-link>
        </ul>
      </div>

      <div class="last">
        <h5 class="title">contacts</h5>
        <ul>
          <li v-for="item in contacts" :key="item.id">
            <div class="img">
              <img :src="require(`@/assets/${item.img}`)" :alt="item.img" />
            </div>
            <a :href="item.href" :target="item.target ? '_blank': ''">
              {{item.title}}
              <br />
              {{item.titleLast}}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p>Created by:</p>
        <div class="img">
          <img :src="require(`@/assets/img/amen-logo.svg`)" alt="amenLogo" />
          <a href="https://amen.team/?utm_source=bportutd"></a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      privacy: [
        { title: "Legal Terms", url: "/legal-terms", id: 1 },
        { title: "Privacy Policy", url: "/privacy-policy", id: 2 },
      ],
      menu: [
        {
          menuTitle: "ClUB",
          list: [
            { title: "About the Club", url: "/about", id: 1 },
            { title: "Team Roster", url: "/players", id: 2 },
            { title: "Staff", url: "/staff", id: 3 },
          ],
        },
        {
          menuTitle: "NEWS",
          list: [
            { title: "Club News", url: "/news", id: 1 },
            { title: "Photo's", url: "/news/photo", id: 2 },
            { title: "Video's", url: "/news/video", id: 3 },
          ],
        },
      ],
      other: {
        menuTitle: "OTHER",
        list: { shop: true, title: "Sponsors", url: "/sponsors", id: 2 },
      },
      contacts: [
        {
          title: "10 Christy Street",
          titleLast: " Norwalk, CT 06850",
          href: "https://goo.gl/maps/kvfPUEQkAtBJbsWF9",
          id: 1,
          img: "img/map-marker.svg",
          target: true,
        },
        {
          title: "502-468-6930",
          href: "tel:+502-468-6930",
          id: 2,
          img: "img/phone-receiver.svg",
          target: false,
        },
        {
          title: "StarbuckPelletierBUFC@gmail.com",
          href: "mailto:StarbuckPelletierBUFC@gmail.com",
          id: 3,
          img: "img/close-envelope.svg",
          target: false,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
$blue: #15224e;
$orange: #fdc65a;
$Mont: "Montserrat", sans-serif;

footer {
  background-color: $blue;
  padding-top: 6rem;
  @media only screen and (max-width: 992px) {
    padding-top: 5rem;
  }
}
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  & > div {
    width: 17%;
    order: 1;
    @media only screen and (max-width: 768px) {
      width: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      margin-bottom: 4rem;
      &:nth-child(2),
      &:nth-child(3) {
        width: 49%;
        padding-right: 2%;
      }
    }
    &:first-of-type {
      width: 23%;
      margin-right: 3.5rem;
      padding-right: 3.9rem;
      @media only screen and (max-width: 992px) {
        padding-right: 0;
        width: 20%;
      }
      @media only screen and (max-width: 768px) {
        width: 100%;
        margin-bottom: 1.5rem;
        margin-right: 0;
        order: 2;
      }
    }
    &:nth-child(3) {
      padding-left: 2.5rem;
      @media only screen and (max-width: 992px) {
        padding-left: 2.5rem;
      }
      @media only screen and (max-width: 768px) {
        padding-left: 0;
      }
    }
    &:nth-child(4) {
      @media only screen and (max-width: 992px) {
        padding-left: 0.5rem;
      }
      @media only screen and (max-width: 768px) {
        padding-left: 0;
      }
    }
    &.last {
      width: 22%;
      padding-left: 1rem;
      @media only screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0;
      }
      ul {
        padding-top: 1rem;
        li {
          position: relative;
          margin-bottom: 3rem;
          padding-left: 3.5rem;
          @media only screen and (max-width: 992px) {
            padding-left: 3rem;
            margin-bottom: 2.3rem;
            &:last-of-type {
              margin-bottom: 0;
            }
          }
          @media only screen and (max-width: 768px) {
            &:first-of-type {
              //max-width: 21rem;
              //text-align: center;
            }
          }
          .img {
            position: absolute;
            left: 0;
            top: 14px;
            transform: translateY(-50%);
            min-width: 1.6rem;
            width: 1.6rem;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
          }
          &:before {
            display: none;
          }
          a {
            color: #e8e8e8;
            font-size: 1.3rem;
            line-height: 2.5rem;
            transition: color 0.3s ease-in-out;
            &:hover {
              color: $orange;
            }
          }
        }
      }
    }
    &:last-of-type {
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      padding: 0.5rem 1rem 2.3rem 0rem;
      width: 23%;
      padding-right: 3.9rem;

      @media only screen and (max-width: 992px) {
        width: 20%;
        padding: 1.2rem 1.4rem 2.3rem 0.7rem;
      }
      @media only screen and (max-width: 768px) {
        order: 3;
        margin-bottom: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        padding-left: 0;
        width: 100%;
      }
      .img {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        a {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
        }
      }
      img {
        margin-left: 1rem;
        cursor: pointer;
      }
      p {
        font-size: 1.1rem;
        font-weight: 500;
        font-family: $Mont;
        color: #f1f1f1;
      }
    }
  }
}
.logo {
  margin-bottom: 3.3rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
  img {
    width: 10.7rem;
    height: 10.7rem;
    margin: 0 auto;
    cursor: pointer;
  }
}
.copyright {
  display: inline-block;
  width: auto;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 2rem;
  color: #f1f1f1;
  text-align: center;
  margin-bottom: 3rem;
  text-transform: initial;
  @media only screen and (max-width: 992px) {
    margin-bottom: 2.5rem;
  }
  @media only screen and (max-width: 768px) {
    display: block;
    text-align: left;
  }
}
.privacy-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  @media only screen and (max-width: 768px) {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
  li {
    font-size: 1.1rem;
    font-weight: 300;
    text-decoration: underline;
    color: #fff;
    cursor: pointer;
    &:first-of-type {
      margin-right: 1.5rem;
      @media only screen and (max-width: 992px) {
        margin-right: 1.2rem;
      }
    }
  }
}
.menu {
  li {
    position: relative;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 4rem;
    color: #e8e8e8;
    padding-left: 2rem;
    cursor: pointer;
    &.not-router {
      transition: none;
    }
    a {
      color: inherit;
    }
    @media only screen and (max-width: 992px) {
      line-height: 2.5rem;
      margin-bottom: 1.5rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    &:before {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      content: "";
      width: 3px;
      height: 3px;
      background: #fdc65a;
    }
  }
}
.title {
  margin-bottom: 1rem;
}

li {
  transition: color 0.3s ease-in-out;
  &:hover {
    color: $orange;
  }
}
</style>